import { DesignTokens } from "../../types"

export const createFonts: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.Fonts = () => ({
  body: "'Open Sans', sans-serif",
})

export const createFontSizes: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.FontSizes = ({ sizes }) => ({
  xSmall: sizes[10],
  small: sizes[12],
  medium: sizes[14],
  large: sizes[16],
  xLarge: sizes[18],
  xxLarge: sizes[20],
  xxxLarge: sizes[24],
  xxxxLarge: sizes[32],
})

export const createLineHeights: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.LineHeights = ({ sizes }) => ({
  xxSmall: sizes[14],
  xSmall: sizes[16],
  small: sizes[18],
  medium: sizes[20],
  large: sizes[24],
  xLarge: sizes[32],
  xxLarge: sizes[36],
})

export const createFontWeights: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.FontWeights = () => ({
  regular: "400",
  semibold: "600",
  bold: "700",
})

export const createTextColors: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.TextColors = ({ colors }) => ({
  default: colors.black,
  inverse: colors.white,
  disabled: colors.gray400,
  subdued: colors.gray600,
  placeholder: colors.gray400,
  link: colors.blue600,
  brand: colors.green400,
  discount: colors.green600,
  price: colors.green600,
  urgent: colors.red600,
  accent: colors.purple600,
  navigation: colors.black,
  action: colors.blue600,
  selection: colors.blue600,
  success: colors.green600,
  informational: colors.blue600,
  error: colors.red600,
  warning: colors.yellow600,
  promotional: colors.green050,
  details: colors.blue400,
})
